import homeBlackIcon from "./homeblack.svg";
import updateBlackIcon from "./update_black.svg";
import printerBlackIcon from "./printer_black.svg";
import accountBlackIcon from "./account_black.svg";
import settingsBlackIcon from "./settings_black.svg";
import undoBlackIcon from "./undo_black.svg";
import shoppingBlackIcon from "./shoppingcart_black.svg";
import purchaseBlackIcon from "./purchase_black.svg";
import integrationConfigBlack from "./integrationConfigBlack.svg";

import homeWhiteIcon from "./home_white.svg";
import updateWhiteIcon from "./update_white.svg";
import printerWhiteIcon from "./printer_white.svg";
import accountWhiteIcon from "./account_white.svg";
import settingsWhiteIcon from "./settings_white.svg";
import undoWhiteIcon from "./undo_white.svg";
import shoppingWhiteIcon from "./shopping_cart_white.svg";
import purchaseWhiteIcon from "./purchase_white.svg";
import emailBlackIcon from "./email_black.svg";
import integrationConfigWhite from "./integrationConfigWhite.svg";

const configIcons = {
  homeBlackIcon,
  updateBlackIcon,
  printerBlackIcon,
  accountBlackIcon,
  settingsBlackIcon,
  undoBlackIcon,
  shoppingBlackIcon,
  purchaseBlackIcon,
  homeWhiteIcon,
  updateWhiteIcon,
  printerWhiteIcon,
  accountWhiteIcon,
  settingsWhiteIcon,
  undoWhiteIcon,
  shoppingWhiteIcon,
  purchaseWhiteIcon,
  emailBlackIcon,
  integrationConfigBlack,
  integrationConfigWhite,
};

export default configIcons;
